<template>
  <div class="user-cta">
    <div class="user-cta">
      <Icon name="grCameraOff" width="36" class="mb-3"/>
      <div class="mb-5">
        <h4 class="user-cta__title">{{ $t('pages.checkins.photos_unavailable_for_event') }}</h4>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CtaPhotosUnavailableForEvent",
  props: {

  }
}
</script>


<style scoped>

</style>